import { useSignal } from "@preact/signals-react"
import { useCallback } from "react"
import { getSubmit } from "@ui-seeker/utils"
import { BACKEND_APIS } from "@constants"
import { MAPPING_TYPE } from "Pages/User/CustomMapping/@constants"
import { acrissTable, categoriesTable } from "Pages/User/CustomMapping/@signals"
import { useToast } from "@hooks"

export default function useCustomMappingTable(path) {
	const isTableLoading = useSignal(false)
	const { showToast } = useToast()

	const getTableData = useCallback(() => {
		isTableLoading.value = true
		getSubmit(`${path === MAPPING_TYPE.ACRISS ? BACKEND_APIS.CUSTOM_ACRISS : BACKEND_APIS.CUSTOM_CATEGORY}/list`).then(res => {
			const processedData = res.map(row => ({
				...row,
				sitesNameRaw: row.sitesName?.map(site => site.nameRaw) || [],
				officesNameFilter: row.officesName?.map(office => office.name) || []
			}))

			if (path === MAPPING_TYPE.ACRISS) {
				acrissTable.value = processedData
			} else {
				categoriesTable.value = processedData
			}
			isTableLoading.value = false
		}).catch(() => {
			showToast.error()
			isTableLoading.value = false
		})

	}, [])


	return {
		getTableData,
		tableData: path === MAPPING_TYPE.ACRISS ? acrissTable.value : categoriesTable.value,
		isTableLoading: isTableLoading.value,
	}
}